import MetaMusic from "./MetaMusic.json"
export const CONTRACT_ADDRESS = "0x5E921d44C04A311d4cC98444513fD88554183E57";
export const ABI = MetaMusic.abi;

    